import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ReasonsBreakdownTableSkeleton = () => (
  <Styles.Container>
    {Array.from({ length: 4 }).map((_, index) => (
      <Skeleton key={index} variant="rounded" width="100%" height={40} />
    ))}
  </Styles.Container>
)

export default ReasonsBreakdownTableSkeleton
